<template>
<div id="app">
  <template v-if="!noHeader">
    <Header :class="header_show ? 'white':'black'" v-if="!header_bg"/>
    <Header class="bg-black white" v-if="header_bg"/>
  </template>
   
    <router-view></router-view>
    <!-- {{footer_show}} -->
    <!-- <Footer :class="footer_show ? '':'hidden'"/> -->
    <div class="view-footer" :class="footerWhite ? 'mywhite':'bg-black'">
      <div class="container-fluid">
        <div class="copyr1 ptb13" v-if="!footer_show" :class="whiteC ? 'white':'black'">All rights reserved <br> Black Nova Ltd.- {{ year() }} | Current release is {{ release_number }}</div>
        <div class="text-center copyr1" v-else>All rights reserved Black Nova Ltd.- {{ year() }} | Current release is {{ release_number }}</div>
      </div>
    </div>

  </div>
</template>

<script>
import Header from './components/Header';
// import Footer from './components/Footer';

export default {
  name: 'app',
  components: {
      Header
      // Footer
  },
  data(){
        return {
            release_number: '2024.06a',
            header_show:true,
            footer_show:true,
            header_bg:true,
            footerWhite:false,
            whiteC:false,
            noHeader: false
        }
      },
    methods:{ 
      year() {
        var d = new Date();
        var n = d.getFullYear();
        return n;
      },
      removeHeader() {
        this.noHeader = true;
      },
      showHeader() {
        this.noHeader = false;
      },
      headerB:function () {
        this.header_show = false;
      },
      headerW:function () {
        this.header_show = true;
      },
      headerNoBg:function(){
        this.header_bg = false;
      },
      headerBg:function(){
        this.header_bg = true;
      },
      //left algin
      footerB:function () {
          this.footer_show = false;
      },
      footerW:function () {
          this.footerWhite = true;
      },
      textWhite:function () {
          this.whiteC = true;
      },
      textBlack:function () {
          this.whiteC = false;
      },
      
  }, 
  watch:{
    $route (){
        this.footer_show = true;
        this.footerWhite = false;
        this.whiteC = false;
    }
} 
  
}
</script>

<style >
@import 'assets/css/custom.css';
</style>

